import React from 'react'

import { Text } from './styles'

import type { ComponentType } from 'react'
import type { Address as AddressType } from '~/types'

export type Props = {
  address: AddressType
  textComponent?: ComponentType<any>
}

const Address = ({ address, textComponent }: Props) => {
  const { street1, country, city, stateProvince, zipPostal } = address

  const StyledText = textComponent || Text

  return (
    <>
      <StyledText data-testid="street">{street1}</StyledText>
      <StyledText>
        {city}
        {stateProvince && `, ${stateProvince}`}
      </StyledText>
      <StyledText>
        {country}
        {zipPostal && `, ${zipPostal}`}
      </StyledText>
    </>
  )
}

export default Address
